import { Flex, useColorModeValue } from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import ManagementTable from "views/admin/staking/components/ManagementTable";
import { tableColumnsManagement } from "views/admin/staking/components/variables/tableColumnsManagement";
import tableDataManagement from "views/admin/staking/components/variables/tableDataManagement.json";
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks";
import { ASTRONAUTS } from "constants/Collection";


export default function Staking() {

    const { address } = useGetAccountInfo();
    const [astronautsData, setAstronautsData] = useState(null);

    // TODO the php/laravel time-staking app is currently down

    // useEffect(async () => {
    //     const response = await axios.get(`${process.env.REACT_APP_TS_API_URL}/snapshot/${address}`)
    //         .catch(e => console.error(e));
    //             setAstronautsData(response.data.data);
    // }, [])

    // So, we just use the elrond api for now and show 100% for all NFTs in the wallet
    useEffect(async () => {
        const response = await axios.get(`https://api.elrond.com/accounts/${address}/nfts?size=3000&collections=${ASTRONAUTS}`)
            .catch(e => console.error(e));
                setAstronautsData(response.data.map((item) => ({
                    name: item.name,
                    image: item.url,
                    today: {
                        percent: 100,
                    },
                    last7Days: {
                        percent: null,
                    },
                    last14Days: {
                        percent: null,
                    },
                    last30Days: {
                        percent: null,
                    },
                })));
    }, [])


    return (
        <Flex pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Flex direction='column' width='stretch'>
                <ManagementTable
                    astronautsData={astronautsData}
                />
            </Flex>
        </Flex>
    );
}
